module.exports = __webpack_public_path__ + "static/media/email-image.4ed965d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dublin-express/email-image.svg
// module id = 706
// module chunks = 0